export const onCloseDialog = ({
  onDismissFocusRef,
  onClose,
}: {
  onDismissFocusRef?: React.RefObject<HTMLElement | null>;
  onClose: () => void;
}): void => {
  if (onDismissFocusRef) {
    onDismissFocusRef.current?.focus();
  }

  onClose();
};
